import debounce from 'lodash/debounce';
import get from 'lodash/get';
import clone from 'lodash/clone';

export default {
  data: function () {
    return {
      // restoreFilter: false to disable auto-restore
      // listPersistencePath: 'VirtualDevice.list'
      // searchMode: ['single'|'multi'|null]
      // accountsMode: ['single'|'multi'|null]
      // favouriteMode: ['on'|null]
    };
  },
  watch: {
    selectedAccount: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }
      this.fetchList(true);
    }, 500),
    selectedAccounts: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }
      this.fetchList(true);
    }, 500),
    tableOptions: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
    // in case of single item search-mode, listen to any update of the category or search-string
    // otherwise listen to the @updated emit from `custom-multi-search` in the target component
    'searchItem.category': debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }
      this.fetchList();
    }, 500),
    'searchItem.item': debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }
      this.fetchList();
    }, 500),
    favouriteFilter: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }
      this.fetchList();
    }, 500),
  },
  created() {
    if (this.restoreFilter !== false) {
      const searchDetails = get(this.$store.state.app, `pageFilters.${this.listPersistencePath}.searchDetails`);
      const searchOperator = get(this.$store.state.app, `pageFilters.${this.listPersistencePath}.searchOperator`);

      if (searchOperator) {
        this.searchOperator = searchOperator;
      }

      if (searchDetails) {
        if (this.searchMode === 'single') {
          this.searchItem = searchDetails;
          // to prevent the fetch to reset to page 1, initialise the last search here
          // this will fetch exactly the same page and same sorting/filter as the last time during this session
          this.lastSearch = clone(searchDetails);
        } else if (this.searchMode === 'multi') {
          this.searchItems = searchDetails;
          this.lastSearch = this.searchItems.map((item) => ({
            variable: item.param,
            // support item.search.value === null, so do not simply have a >search.value || search< expression
            search: (item.search || {}).value === undefined ? item.search : item.search.value,
          }));
        }
      }
    }
    // NOTE: there is a global persistence of account-filters in `core-account-filter` now,
    // unless for THIS specific component there should be a separate filter, preferrable use that way instead
    const accountFilter = get(this.$store.state.app, `pageFilters.${this.listPersistencePath}.accountFilter`);
    if (accountFilter) {
      if (this.accountsMode === 'single') {
        this.selectedAccount = accountFilter;
      } else if (this.accountsMode === 'multi') {
        this.selectedAccounts = accountFilter;
      }
      const favouriteFilter = get(this.$store.state.app, `pageFilters.${this.listPersistencePath}.favouriteFilter`);
      if (favouriteFilter !== undefined && favouriteFilter !== null) {
        if (this.favouriteMode === 'on') {
          this.favouriteFilter = favouriteFilter || false;
        }
      }
    }
    // restoreFilter: false means this instance is embedded in some other context (e.g. a
    // device template's related-devices tab) and must not inherit paging state left behind
    // by an unrelated instance that shares the same listPersistencePath
    this.tableOptions =
      this.restoreFilter !== false
        ? get(this.$store.state.app, `pageFilters.${this.listPersistencePath}.tableOptions`) || {
            ...this.defaultTableOptions,
          }
        : { ...this.defaultTableOptions };

    if (this.initializedDefaultPageFilters && typeof this.initializedDefaultPageFilters === 'function') {
      this.initializedDefaultPageFilters();
    } else {
      this.fetchList();
    }
  },
  methods: {
    // something
  },
};
